import type { ImageFile } from "@/utils/types/types";

// Reusable placeholder uploads (2026-09-03, Michael). These live in the ADMIN
// account as ordinary processed uploads (so the visualizer + job builder have
// real dimensions and raw/thumbnail variants), but are pinned by FILE NAME:
//   - always at the top of the admin Upload page, even once used in orders
//   - no delete / hide controls, no in-cart / order badges
//   - the backend delete route refuses them (delete-s3-upload.ts)
// Re-uploading a file with the same name keeps the pin without a code change.
// Listed in this order at the top of the admin Upload page — most-used first (Michael 09-24).
export const PLACEHOLDER_UPLOAD_ORDER = [
  "CustomerSuppliedArt.jpg",
  "MultiWindowMat.jpg", // multi-window mat line (stores/multiWindow.ts, 09-23)
];
export const PLACEHOLDER_UPLOAD_NAMES = new Set(PLACEHOLDER_UPLOAD_ORDER);

export const PLACEHOLDER_UPLOAD_CAPTION: Record<string, string> = {
  "CustomerSuppliedArt.jpg":
    "Reusable placeholder — customer supplied art, no digital file",
  "MultiWindowMat.jpg":
    "Reusable placeholder — multi-window mat (size = glass size; prints on their own lines)",
};

export function isPlaceholderUpload(image?: Pick<ImageFile, "name"> | null) {
  return !!image && PLACEHOLDER_UPLOAD_NAMES.has(image.name);
}
